<template>
    <div>
        <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>
        <div class="row">
            <div class="col-md-3">
                <filters-general ref="filtersReport"></filters-general>
            </div>
            <div class="col-md-9">
                <div class="row">
                    <div class="col-md-4 text-center"></div>
                    <div class="col-md-4 text-center">
                        <button class="btn ripple btn-primary" @click="getReportPrecios">Generar Reporte </button>
                    </div>
                    <div class="col-md-4" v-if="showResultPrecios">
                        <div v-if="loadfilePrecios">
                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                            <p>Preparando archivo, espere...</p>
                        </div>
                        <button v-if="!loadfilePrecios"  class="btn btn-success" type="button" @click="ExportFilePrecios"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Descargar Excel</b></button>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-center">
                            <div v-if="loadingGetDataPrecios">
                                <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                                <p>Preparando información, espere...</p>
                            </div>
                        </div>
                    </div><br>
                    <div class="col-md-12" v-show="showResultPrecios">
                        <v-client-table :data="tableDataPrecios" :columns="columnsPrecios" :options="optionsPrecios" class="table-responsive" ref="tablePromociones">
                            <div slot="Comentario" slot-scope="props" class="text-center">
                                <span v-if="props.row.Descuento !== '0'">{{ props.row.Comentario }}</span>
                            </div>
                        </v-client-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tablaPrecios",
    data(){
        return{
            loadfilePrecios:false,
            showResultPrecios:false,
            loadingGetDataPrecios: false,
            showDataPrecios: false,
            columnsPrecios: ['Fecha','Semana','Area','Agencia','Tipo','Rol','Usuario','Estado','Ciudad','Canal','Cadena','Formato','Tienda','Fabricante','Departamento','Categoria','Marca','Codigo','Producto','Prc','Descuento','Comentario'],
            tableDataPrecios: [],
            optionsPrecios: {
                footerHeadings:false,
                filterByColumn:true,
                perPage:5,
                perPageValues: [5,10],
                filterable: ['Usuario','Tienda','Area','Formato','Canal','Cadena','Codigo','Producto','Prc'],
                sortIcon:
                    { base:'fontawesome', up:'fas fa-long-arrow-alt-up', down:'fas fa-long-arrow-alt-down', is:'fas fa-sort' }
                ,
                listColumns: {
                },
                cellClasses:{
                },
                columnsDropdown:false,
                headings: {
                    Id: '#',
                    Fecha: 'Fecha Hora Registro',
                    Gestor: 'Usuario',
                    Prc: 'Precio',
                },
                columnsClasses: {
                    Id: 'text-center font-bold text-danger',
                    Descuento: 'text-center font-bold text-info',
                    Producto: 'text-center',
                    Gestor: 'text-center',
                    Tienda: 'text-center',
                    Area: 'text-center',
                    Formato: 'text-center',
                    Canal: 'text-center',
                    Cadena: 'text-center',
                    Fecha: 'text-center',
                    Prc: 'text-center',
                    Comentario: 'text-justify',
                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtro:",
                    filterPlaceholder: "Buscar:",
                    limit: "Registros:",
                    page: "Pagína:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar",
                    loading: 'Buscando...',
                    defaultOption: 'Todos',
                    //defaultOption: 'Elige {column}',
                    columns: 'Columnas'
                },
            },
        }
    },
    mounted() {
        this.$refs.filtersReport.shows.trades = false;
    },
    methods:{
        keyboardEvent (e) {
            if (e.which === 13) {
                this.getReportPrecios();
            }
        },
        getReportPrecios(){ let $this = this;
            var filters = this.$refs.filtersReport.filters;
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center');
            }else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center');
            }else{
                this.loadingGetDataPrecios = true;
                this.showDataPrecios = false;
                this.showResultPrecios = false;
                this.tableDataInventario = [];
                axios.post('/api/Precios/Tabla',{data:filters, tipo: 1})
                    .then(r => {
                            $this.loadingGetDataPrecios = false;
                            $this.showDataPrecios = true;
                            $this.tableDataPrecios = r.data.Data;
                            $this.showResultPrecios = true;
                        },
                        error => {
                            $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                        }
                    );
            }
        },
        ExportFilePrecios(){let $this = this;
            this.loadfilePrecios = true;
            var filters = this.$refs.filtersReport.filters;
            axios({
                method: 'post',
                url: '/api/Precios/exportLayoutToExcel',
                responseType: 'arraybuffer',
                data: { data: filters, tipo: 1 }}).then(r => {
                    let blob = new Blob([r.data], { type: 'application/xlsx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'PreciosMoet.xlsx'
                    link.click()
                    $this.loadfilePrecios=false;
                },
                error => {
                    $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                    $this.loadfilePrecios=false;
                }
            );
        },
    }
}
</script>

<style scoped>

</style>
